import React, { useRef, useState } from 'react'
import QRCode from 'react-qr-code'
import { Link, useParams } from 'react-router-dom';
import { ConfirmDelete, MwInputText, MwSpinnerButton } from '../../components/ui';
import { FaRegEdit } from "react-icons/fa";
import { LuPrinter } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { MdContentCopy } from "react-icons/md";
import QrPrintableService from './QrPrintableService';
import { useTranslation } from 'react-i18next';
import { printableDiv } from '../../utils/global';

const RatingServicesListItem = ({ showConfirmDelete, setShowConfirmDelete, selectedDeleteId, setSelectedDeleteId, deleteLoading, deleteHandler, item }) => {
    const [t] = useTranslation('global')
    const params = useParams();
    const _qrValue = `${process.env.REACT_APP_RATING_WEB_USER_BASE_URL}/${params.tenant}/${item._id}`;
    const printableRef = useRef(null);
    const [copied, setCopied] = useState(false);

    const Print = () => {
        if (!printableRef.current) return;
        printableDiv(printableRef);
    }

    const deleteItemHandler = () => {
        if (selectedDeleteId) {
            deleteHandler(selectedDeleteId);
        }
    }

    const copyLinkHandler = async () => {
        try {
            await navigator.clipboard.writeText(_qrValue);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (error) {
            setCopied(false);
        }
    }

    return (
        <>
            <ConfirmDelete
                setOnShow={setShowConfirmDelete}
                onShow={showConfirmDelete && selectedDeleteId === item._id}
                onDeleteHandler={deleteItemHandler}
                onCancelHandle={() => setSelectedDeleteId('')}
                loading={deleteLoading}
                msg={t('services.confirmDelete')}
            />
            {
                !deleteLoading ?
                    <div className='relative border border-slate-200 rounded-3xl bg-white p-6 shadow-sm overflow-hidden' >
                        {copied && (
                            <div className='absolute top-3 right-3 text-[10px] bg-emerald-50 text-emerald-700 px-2 py-1 rounded-full border border-emerald-100'>
                                {t('services.linkCopied')}
                            </div>
                        )}
                        <div className={`absolute top-0 left-0 right-0 h-1.5 ${item.isActive ? 'bg-green-500' : 'bg-slate-300'}`}></div>

                        <div className='flex justify-between items-start mb-4'>
                            <span className={`rounded-full text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 ${item.isActive ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'}`}>
                                {item.isActive ? t('common.active') : t('common.inactive')}
                            </span>
                            {item.isDefault && (
                                <span className='rounded-full text-[10px] font-bold uppercase tracking-wider bg-amber-100 text-amber-700 px-2.5 py-1'>
                                    {t('services.default')}
                                </span>
                            )}
                        </div>

                        <Link to={`/${params.tenant}/rating/${item._id}`} className='block mb-6'>
                            <div className='text-center mb-6'>
                                <h3 className='text-lg font-bold text-slate-800 line-clamp-1'>{item.serviceName}</h3>
                                <p className='text-xs text-slate-400 mt-1 italic'>{t('services.clickToReview')}</p>
                            </div>

                            <div className='bg-slate-50 p-6 rounded-2xl flex justify-center items-center border border-transparent shadow-inner'>
                                <QRCode
                                    size={120}
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                    value={_qrValue}
                                    viewBox={`0 0 128 128`}
                                    fgColor="#1e293b"
                                />
                            </div>
                        </Link>

                        <div className='space-y-4'>
                            <div className='flex items-end gap-2'>
                                <div className='flex-1'>
                                    <MwInputText
                                        label={t('services.ratingLink')}
                                        value={_qrValue}
                                        disabled={true}
                                        className="text-[10px]"
                                        onChange={() => { }}
                                    />
                                </div>
                                <button
                                    onClick={copyLinkHandler}
                                    className='p-2 rounded-xl bg-slate-50 text-slate-600 hover:bg-emerald-500 hover:text-white transition-all duration-200'
                                    title={t('services.copyLink')}
                                >
                                    <MdContentCopy size={16} />
                                </button>
                            </div>

                            <div className='flex gap-2 pt-2 border-t border-slate-50'>
                                <button
                                    onClick={Print}
                                    className='flex-1 flex justify-center items-center gap-2 py-2 rounded-xl bg-slate-50 text-slate-600 hover:bg-slate-900 hover:text-white transition-all duration-200'
                                    title={t('common.print')}
                                >
                                    <LuPrinter size={16} />
                                    <span className='text-xs font-medium'>{t('common.print')}</span>
                                </button>

                                <Link
                                    to={`/${params.tenant}/rating-services/edit/${item._id}`}
                                    className='p-2 rounded-xl bg-slate-50 text-slate-600 hover:bg-blue-500 hover:text-white transition-all duration-200'
                                    title={t('common.edit')}
                                >
                                    <FaRegEdit size={16} />
                                </Link>

                                <button
                                    onClick={() => {
                                        setSelectedDeleteId(item._id);
                                        setShowConfirmDelete(true);
                                    }}
                                    className='p-2 rounded-xl bg-slate-50 text-slate-600 hover:bg-red-500 hover:text-white transition-all duration-200'
                                    title={t('common.delete')}
                                >
                                    <AiOutlineDelete size={16} />
                                </button>
                            </div>
                        </div>
                    </div> :
                    <div className='h-80 flex items-center justify-center bg-slate-50 rounded-3xl border-2 border-dashed border-slate-200'>
                        <MwSpinnerButton withLabel={false} isFullCenter={true} />
                    </div>
            }
            <QrPrintableService item={item} printableRef={printableRef} />
        </>
    )
}

export default RatingServicesListItem
